import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ScrollIndicatorService {

  showScrollIndicator = false;
  userScrolled = false;
  viewportHeight = 0;

  reset(): void {
    this.showScrollIndicator = false;
    this.userScrolled = false;
    this.viewportHeight = 0;
  }

  hide(): void {
    this.showScrollIndicator = false;
    this.userScrolled = true;
  }
}
